module.exports = __webpack_public_path__ + "public/images/Illustration_Pencil_200x200-Color.01029037e9cd1ed137991aa7cc7389df.png";